import type { StaticTextLookupKey } from '../../src/translators/static-text-lookup';

export enum Country {
  BELGIUM = 'Belgium',
  FRANCE = 'France',
  GERMANY = 'Germany',
  IRELAND = 'Ireland',
  ITALY = 'Italy',
  NETHERLANDS = 'Netherlands',
  SPAIN = 'Spain',
  SWITZERLAND = 'Switzerland',
  UNITED_KINGDOM = 'United Kingdom',
  LUXEMBOURG = 'Luxembourg',
}

export type CountriesToSplitIntoRegions = Country.UNITED_KINGDOM;

export const getTranslationKeyForCountry = (country: Country): StaticTextLookupKey => {
  switch (country) {
    case Country.BELGIUM:
      return 'countryBelgium';
    case Country.FRANCE:
      return 'countryFrance';
    case Country.GERMANY:
      return 'countryGermany';
    case Country.IRELAND:
      return 'countryIreland';
    case Country.ITALY:
      return 'countryItaly';
    case Country.NETHERLANDS:
      return 'countryNetherlands';
    case Country.SPAIN:
      return 'countrySpain';
    case Country.SWITZERLAND:
      return 'countrySwitzerland';
    case Country.UNITED_KINGDOM:
      return 'countryUnitedKingdom';
    case Country.LUXEMBOURG:
      return 'countryLuxembourg';
    default:
      throw new Error('Unsupported country');
  }
};
